// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer-module--footer-container--0Uu1-","p":"Footer-module--p--+cTUk"};